export default {
  token: '请先登录您的账号',
  navbar: {
    login: '登录',
    logOut: '退出',
    register: '免费注册',
    cart: '进货单',
    member: '会员中心',
    appDownload: 'APP 下载',
    seller: '卖家版 APP',
    buyer: '买家版 APP',
    sellerTitle: '小商品城卖家版APP',
    buyerTitle: '小商品城买家版APP',
    ios: 'iOS下载',
    android: 'Android下载',
    cooperation: '商家/合作方登录',
    download: '扫码下载APP',
    Cyber: '网络文化',
    Member: '会员申请'
  },
  lang: {
    zh: '简体中文',
    en: 'English',
    ko: '한국어'
  },
  market: {
    map: '小商品城地图',
    introduce: '小商品城介绍',
    notice: '小商品城公告',
    path1: '1路',
    path2: '生产资料专线',
    time: '发车时刻表',
    particulars: '查看市场详情',
    bazaar: '市场详情',
    home: '首页',
    msg: '市场信息',
    rank: '市场店铺排行',
    toshop: '进店看看',
    attention: '关注店铺',
    score: '分',
    Scan: '扫一扫，手机查看',
    marketRank: '市场排名',
    buyPhone: '手机购买',
    Nmarket: '市场第',
    homePage: '义乌小商品城Chinagoods.com–义乌市场贸易综合服务平台',
    circuit1: '班车时刻表',
    circuit2: '生产资料专线'
  },
  menus: {
    describe: '全链路 全场景 数字化贸易综合服务平台',
    home: '首页',
    purchase: '首页',
    welcomeToYiwu: '走进义乌',
    logistics: '物流集散',
    financial: '信用金融',
    customerService: '客服在身边',
    market: '实体市场',
    international: '国际布局'
    // PDwholesalecenters: '物流集散'
  },
  navigation: {
    personalAlive: '私密视频',
    personalGoods: '私密商品',
    demandGoods: '找货需求',
    productType: '商品分类',
    serveType: '市场区块',
    customerCenter: '客服中心',
    sellerEntry: '卖家登录',
    marketService: '服务频道'
  },
  newJoin: {
    dataDoenload: '资料下载',
    ranking: '排行榜',
    floorLayout: '楼层介绍',
    Keywords: '搜索关键词',
    createAccount: '注册',
    quickCreate: '立即注册',
    welcome: 'Hi，欢迎来义乌！',
    getNews: '新闻通知',
    privacy: '我已阅读并同意《小商品城用户隐私政策》',
    privacy1: '我已阅读并同意',
    privacy2: '《小商品城用户隐私政策》',
    codeLogin: '账号密码登录 ',
    yCodeLogin: '验证码登录',
    readAgree: '请同意用户协议',
    invationCode: '请输入邀请码',
    quickJoin: '服务类商品合作伙伴火热招募中！立即加入'
  },
  personCnter: {
    noNeeds: '暂无需求',
    noLive: '暂无视频',
    noProducts: '暂无商品',
    noAddress: '暂无地址',
    noOrderer: '暂无订购人',
    noCharts: '暂无消息',
    noOrders: '暂无订单',
    noQuestions: '暂无工单',
    noInfo: '暂无内容',
    noStore: '暂无店铺',
    noGuests: '暂无房客',
    noHotels: '暂无酒店',
    rzfuwu: '融资服务',
    myNeeds: '我的需求',
    smallMarket: '小商品城实体市场'
  },
  intoYiwu: {
    walkInto: '走进义乌',
    yiwuDescribe: '一座建在市场上的城市',
    welcome: '义乌——热忱欢迎您的到来！',
    yiwuInfomation:
      '习近平总书记多次在国际外交场合介绍义乌，并把义乌定位世界“小商品之都”。商城集团积极配合义乌市政府，为世界各地来义乌的客商提供从出入境办理、商务贸易到本地生活的各项服务，让各方都能轻松来义乌轻松做交易，实现“买全球货，卖全球货”的国际化格局。',
    seeMap: '查看地图',
    scenic: '4A景区介绍',
    yiwuGuid: '外国人服务',
    yiwuGuid1: '采购商服务',
    yiwuGuid2: '义乌展会',
    yiwuGuid3: '物业租售',
    hotel: '酒店预定',
    content:
      '配合义乌市出入境管理部门，为前来义乌的外籍人士提供各项设外政务及贸易事项的一网通办平台。',
    content1:
      '为经营户及外籍采购商，提供市场贸易生活等政策咨询，外商公司注册、外国人工作许可证、外国人居留许可等涉外服务业务的引导与代办。',
    content2:
      '义博会、五金会、进口展、海外展、森博会……欢迎五洲四海的朋友通过参加展会来到义乌认识义乌开启贸易之旅。',
    content3:
      '商城集团旗下六大酒店，为您提供最优惠的价格最优质的住宿、餐饮及会议服务，是您来义乌市场最合适的下榻之所。',
    // content4: '商城·物产跨境（进口）电商园位于规划中的义乌保税港区核心地段，包括有写字楼、星级酒店、商业、仓储及停车场等',
    content4:
      '商城集团旗下地产物业版块为您提供包括写字楼、科技园区、住宅公寓等各种类型的商业及居住类物业的出售与出租。'
  },
  logisticsFinancial: {
    financialTitle: '信用金融',
    financialTitle2: '信用是贸易、金融的立身之本',
    contentTille1: '信用预警',
    contentTille2: '贸易保险',
    contentTille3: '产业金融',
    content1:
      '以社会化为支撑、以专业化为保障，提出了以互联网为载体、以市场为切入点，义乌国际贸易综合服务及经济案事件预警平台于2009年9月18日投入正式运行',
    content2:
      '商城集团携手中国信保，在信用保险、出口融资、信息咨询、应收账款管理等方面为外贸企业提供快捷、完善的服务，为企业积极开拓海外市场提供收汇风险和出口融资保障',
    content3:
      '义乌小商品城与商城征信、经侦平台数据相互打通，把各系统内企业信息进行关联，为访问者提供全方位的贸易预警信息',
    content4: '推进市场信用体系建设，强化金融资源整合和产融良性互动。',
    enter: '进入',
    company: '中国出口信用保险公司',
    viewAll: '查看全部',
    logisticsTitle: '物流集散',
    logisticsTitle1: '义乌是国家级物流枢纽中心',
    listTitle: '义乌物流优势',
    listTitle1: '义乌综合保税区',
    listTitle2: 'e-WTP节点',
    yxo: '义新欧班列',
    listContent:
      '义乌是全国首批17个国际陆港城市之一，是国家物流枢纽承载城市（义乌商贸服务型国家物流枢纽入选首批国家物流枢纽建设名单）。',
    listContent0:
      '义乌2019年1-12月国内邮政和快递业务量累计完成48.84亿件，快递业务量全国城市排名第二位，位列广州之后，北京上海深圳之前。',
    listContent1:
      '义乌综合保税区以eWTP数字贸易为引领，保税展贸为核心，保税物流、保税加工为支撑，保税服务为创新，致力于打造业态高端多元、功能布局完善、服务优质高效的内陆示范引领型海关特殊监管区域；探索发展境内境外打通的数字贸易新业态，推动义乌小商品国际贸易转型升级。',
    listContent2:
      'e-WTP是阿里巴巴集团倡导的电子世界贸易平台，帮助全球发展中国家、中小企业、年轻人更方便地进入全球市场、参与全球经济。2019年6月，义乌与阿里签订战略合作协议，共同建设eWTP全球创新中心。',
    listContent3:
      '自2014年9月，习近平主席首次提出“义新欧”铁路计划，“义新欧”班列已经打通亚欧大陆“从太平洋直达大西洋”的互联互通，至今已共开通从义乌出发运行12个方向的国际班列线路。',
    logisticsInfo: '商城仓储',
    logisticsInfo1: '环球义达',
    logisticsInfo2: '第三方物流服务',
    warehouse: '后宅',
    warehouse1: '廿三里',
    warehouse2: '商贸城物流仓储园',
    despatchWay: '拼箱发货',
    despatchWay1: '整箱发货',
    despatchWay2: '询价',
    logisticsWay: '短驳',
    logisticsWay1: '快递',
    logisticsWay2: '国内物流',
    thirdDescribe1:
      '集团围绕市场上下游业务，发展贸易仓储、小微创业园、小微物流园等业态，强化义乌集货仓、区域仓、海外仓服务承载能力，深度切入贸易链各个环节，构建“物流仓储+”服务体系。',
    thirdDescribe2:
      '环球义达将致力于打造高度标准化、信息化、可视化的物流信息平台，整合义乌碎片化物流需求，赋能义乌贸易主体及货代企业，提供更便捷、高效、低成本的通关物流服务。',
    thirdDescribe:
      '在Chinagoods平台上，将择优接入各类物流服务供应商，为义乌小商品城线上线下市场提供包括短驳、快递、海运、空运等方式在内的国内国际优质物流服务。',
    marketTitle: '实体市场',
    marketTitle1: '全球最大的小商品批发市场',
    marketDescribe1: '义乌中国小商品城创建于1982年，现拥有营业面积640余万平方米',
    marketDescribe2:
      '商位7.5万个，从业人员21万多，日客流量21万人次，经营26个大类、210万个单品。被联合国、世界银行与摩根士丹利等权威机构称为“全球最大的小商品批发市场”',
    square: '',
    detailIntroduction: '详细介绍',
    joinMarket: '入驻市场',
    squareMetre: '平方米',
    shangwei: '个商位',
    dalei: '个大类',
    wan: '万',
    shang: '7.5万',
    kind: '210万',
    typeBusiness: '种商品',
    seeDetails: '查看详情',
    bookHotel: '点击预定',
    logCompany: '物流合作伙伴火热招募中！',
    area: '640万'
  },
  mapinfo: {
    nationTitle: '国际布局',
    nationTitle2: '紧跟国家走出去战略，当好国企排头兵',
    itinerary: '国家一带一路战略',
    operating: '已运营网点',
    preparation: '筹备中网点',
    panama: '巴拿马',
    ethiopia: '埃塞俄比亚',
    gibbdike: '吉布堤',
    burma: '缅甸',
    Korea: '韩国',
    Spain: '西班牙',
    Germany: '德国',
    Czechia: '捷克',
    Rwanda: '卢旺达',
    UnitedArabEmirates: '阿联酋',
    Yiwu: '中国义乌',
    Japan: '日本',
    Operator: '运营主体',
    Office: '办公室',
    Showroom: '展厅',
    cChu: '仓储'
  },

  category: {
    all: '全部分类',
    hotRanking: '热销排行',
    shopRanKing: '店铺排行',
    explosion: '时令爆款',
    live: '视频看店',
    notice: '通知发布',
    marketIntroduction: '市场介绍',
    deatilDesc: '详细内容'
  },

  footer: {
    txt1: '国企信誉保障',
    txt2: '经营户可靠',
    txt3: '物流成本低',
    txt4: '进出口便捷',
    listOne: '合作申请',
    listOne1: '市场经营户',
    listOne2: '生产厂商',
    listOne4: '参展商',
    listOne3: '第三方机构',
    listOne5: '专业人士',
    listTwo: '卖家中心',
    // listTwo1: '卖家登录',
    listTwo1: '店铺开通',
    listTwo2: '平台规则',
    listTwo3: '服务频道',
    // listTwo4: '物流集散',
    listTwo4: '贸易保险',
    listTwo5: '产业金融',
    listThree: '购物指南',
    listThree1: '免费注册',
    listThree2: '购买流程',
    listThree3: '合同订单',
    listThree4: '支付方式',
    listThree5: '常见问题',
    listFour: '关于我们',
    listFour1: '走进义乌',
    listFour2: '市场介绍',
    listFour3: '重要通知',
    listFour4: '国际布局',
    listFour5: '商城集团',
    listFour6: '平台介绍',

    txtContent:
      '平台开发及运营方商城集团是义乌市最大的国企上市集团（SH.600415），也是义乌小商品城实体市场的管理方。',
    txtContent1:
      '在Chinagoods平台上线上出售商品的店铺，都在义乌小商品城拥有线下实体店铺，接受双重管理确保交易可靠。',
    txtContent2:
      '义乌是国家物流枢纽，2019年快递量仅次于广州，从义乌发运世界各地的物流成本低廉，可有效降低整体交易成本。',
    txtContent3:
      '义乌已获批综保区，尤其是多年外向型经济的发展，让义乌有着得天独厚的进出口政策、资源及相关的专业人员。',
    buyAppDownload: '买家App下载',
    hotline: '市场服务热线',
    onToFive: '周一至周日 8：30—17：00',
    zheSafe: '浙公网安备',
    netWorkTrue: '网络文化经营许可证',
    telecom: '增值电信业务经营许可证',
    zhe: '浙',
    zheWwen: '浙网文',
    zheWwenNum: '(2020)1471-068号',
    radioTv: '广播电视节目制作经营许可证',
    zheNum: '（浙）字第 05037 号',
    marketName: '市场名称登记证',
    indystry: '工商市字',
    indystryNum: '3307821094号',
    officialLink: '官方链接',
    attention: '扫码关注微信公众号',
    commodity: '隐私权声明及保护政策',
    record: '备案',
    recordZhe: '浙ICP备',
    recordNum: '20008226号',
    zheCompany: '浙江中国小商品城集团股份有限公司',
    recordCopy: '©2020',
    company: '义乌中国小商品城大数据有限公司',
    copyRight: '版权所有',
    userSerect: '用户服务协议',
    downloadMore: '下载更多APP',
    yiwcompany: '©2021义乌中国小商品城大数据有限公司版权所有',
    yiwcompany2: '©2021义乌中国小商品城互联网金融信息服务有限公司版权所有',
    zheChinaCompany: '浙江中国小商品城集团股份有限公司（ 600415） 唯一官方网上平台'
  },
  shop: {
    favorite: '收藏本店',
    advisory: '在线咨询',
    videoCall: '视频通话',
    category: '主营商品',
    desc: '店铺介绍',
    home: '店铺首页',
    map: '地图导航',
    photo: '相册',
    commodity: '本店商品',
    detailDesc: '详细介绍',
    recommend: '掌柜推荐',
    qualification: '资质',
    buyerRating: '总累积买家评分',
    evaluation: '评价',
    star: '星',
    ranking: '名',
    betterThan: '好于',
    similarBusinesses1: '的同品类商家',
    similarBusinesses2: '的全市场商家',
    monthlyTurnoverRanking: '最近月成交排名',
    honor: '荣誉资质',
    shopNavigation: '店铺导航',
    viewShop: '查看店铺',
    phone: '联系电话',
    date: '营业时间',
    main: '主营',
    dayRanking: '当日成交金额排名 (位)',
    dayNumber: '当日成交订单数 (笔)',
    market: '市场总',
    typeStar1: '1星',
    typeStar2: '2星',
    typeStar3: '3星',
    typeStar4: '4星',
    typeStar5: '5星',
    store: '实体店铺',
    selectPro: '精选商品',
    productAll: '全部商品',
    live: '视频看店',
    Scan: '扫一扫，手机查看',
    score: '分',
    shopmap: '店铺地图',
    talents: '人才招聘',
    phyShopIntroduce: '实体店铺介绍',
    cancel: '取消关注'
  },
  live: {
    live1: '视频',
    live2: '正在播放',
    replay: '回放',
    treasurerLive2: '掌柜正在直播',
    wonderfulPlayback: '精彩回放',
    toChatWith: '和主播聊点什么？',
    switchLive: '切换直播',
    isLiving: '店铺掌柜正在直播',
    comeandWatch: '快来观看吧',
    have: '有',
    newInfo: '条新信息',
    tryAgain: '回放正在转码中，请稍后重试',
    relateGoods: '相关商品',
    noPower: '当前为私密视频，您暂无权限观看',
    interaction: '发言，参与主播互动',
    attention: '关注'
  },
  member: {
    photo: {
      title: '专属相册'
    },
    status: {
      contract: '查看合同',
      pay: '付款'
    },
    order: {
      all: '全部',
      selfCenter: '个人中心',
      allOrder: '所有订单',
      detail: '订单详情',
      wareAddr: '仓库地址',
      shipper: '提货人',
      title: '我的订单',
      orderDate: '下单时间',
      cacelDate: '取消时间',
      paymentDate: '付款时间',
      returnDate: '退货时间',
      revokeReturn: '撤销退货',
      orderInfo: '订单信息',
      orderNumber: '订单号',
      business: '购买商家',
      paymentType: '付款方式',
      wxpay: '微信支付',
      cash: '现金支付',
      alipay: '支付宝支付',
      cardpay: '刷卡支付',
      orderStatus: '订单状态',
      address: '收货地址',
      orderer: '订货人',
      logistics1: '物流',
      logistics2: '物流方式',
      payTheBalance: '支付尾款',
      cancelOrder: '取消订单',
      applyReturn: '申请退货',
      refundCancel: '取消退款',
      refundCheck: '退款待确认',
      returnOut: '退货完成',
      refunding1: '退款中',
      refunding2: '退货中',
      delayedReceipt: '延迟收货',
      confirmReceipt: '确认收货',
      toEvaluate: '去评价',
      postAReview: '发表评价',
      overview: '综合评价',
      myComment: '我的评价',
      cancelReturns: '取消退货',
      returnsDetail1: '退款详情',
      returnsDetail2: '退货详情',
      merchantReply: '商家回复',
      viewLogistics: '查看物流',
      pendingPayment: '待付款',
      orderCancelled: '订单已取消',
      toBeDelivered: '待发货',
      to_pay: '待支付',
      shipped: '已发货',
      comment: '待评价',
      completed: '已完成',
      refund: '退款中',
      toCheck: '待确认',
      cancel: '已取消',
      refundConfirm: '商家已同意退款',
      refundSuccess: '退款成功',
      refundDown: '退款关闭',
      warehouse: '仓库自提',
      sendGoods: '快递直接发货',
      selfTake: '现场自提',
      logisticNews: '暂无物流信息',
      commentTips: '您对此交易满意吗？说说你的意见及建议吧~',
      returnTips1: '您已成功提交退货申请，请耐心等待商家处理。',
      returnTips2: '商家已同意退货，退款总金额',
      returnTips3: ' 商家收到货后，退款将原支付方式返回。',
      orderSearchTips: '请输入商品订单或商品名称',
      emptyEvaluationTips: '您没有填写评价内容',
      deletePrompt: '取消后订单无法恢复，确认取消吗？',
      returnPrompt: '撤销退货后，该商品不可再申请退货，确认撤销退货吗？',
      calcelTit: '取消订单？',
      calcelTits: '取消后订单无法恢复，确认取消吗？',
      cancelSuc: '成功取消订单',
      cancelOprate: '取消操作',
      to_send: '待发货',
      to_sign: '待签约',
      toPayDeposit: '待付定金',
      toPayFinal: '待付尾款',
      toReceive: '待收货',
      balanceToBePaid: '尾款待支付',
      invalid: '无效',
      toStockUp: '备货中',
      evaluateSuc: '评价成功',
      receptSuc: '确认收货成功',
      rateTit: '请选择评价星级',
      changeTelephone: '手机号修改',
      payStatus: '支付状态',
      close: '交易关闭',
      serviceProvider: '服务商',
      transfer: '转单号'
    },
    privacy: {
      title: '私密商品&视频'
    },
    favorite: {
      title: '我的收藏',
      shop: '店铺',
      commodity: '商品',
      category: '分类',
      allMarkets: '全部市场',
      title2: '已收藏的店铺',
      market: '市场',
      HY: '篁园',
      BW: '宾王',
      FH: '孵化区',
      viewCode: '扫码查看'
    },
    address: {
      title: '收货地址',
      subTitle: '收货地址管理',
      receiver: '收货人',
      phone: '手机号码',
      operating: '操作',
      addAddress: '新增收货地址',
      changeAddress: '修改收货地址',
      setAsDefault: '设为默认',
      defaultAddress: '默认地址',
      name: '收货人姓名',
      citizenship: '国籍',
      area: '所在地区',
      address1: '地址',
      address2: '详细地址',
      deletePrompt: '删除地址后无法恢复，确认删除吗？',
      country: '国家'
    },
    orderer: {
      title: '订购人',
      subTitle: '订购人管理',
      addOrderer: '新增订购人',
      changeOrderer: '修改订购人',
      defaultOrderer: '默认订购人',
      name: '姓名',
      idType: '证件类型',
      idNumber: '证件号码',
      setAsDefault: '设为默认',
      operating: '操作'
    },
    myInfo: {
      title: '个人信息',
      telephone: '手机号',
      password: '登录密码',
      email: '电子邮箱',
      unbounded: '未绑定',
      changeTelephone: '手机号码修改/新增',
      changeEmail: '电子邮箱修改/新增',
      changePassword: '登录密码修改',
      changeDetail: '资料修改',
      word1: {
        title: '手机号码修改',
        code: '验证码',
        codeError: '验证码错误',
        getCode: '获取验证码',
        changePassword: '登录密码修改',
        newPassword: '新密码',
        changeEmail: '电子邮箱修改',
        email: '电子邮箱',
        pleaseCode: '请输入验证码',
        pleaseEmail: '请输入电子邮箱',
        pleaseNewpassword: '请输入新密码',
        pleasePassword: '请输入密码'
      },
      authentication: '实名认证'
    },
    news: {
      title: '消息通知',
      titleContent: '消息内容',
      date: '时间',
      operating: '操作',
      tips: '标记为已读',
      open: '展开账号',
      packup: '收起账号'
    },
    work: {
      title: '我的投诉',
      allWork: '全部工单',
      processing: '处理中',
      processed: '已处理',
      addWork: '新建工单',
      number: '序号',
      workNumber: '工单号码',
      problemDescription: '问题描述',
      updateDate: '更新时间',
      addDate: '提交时间',
      type1: '类型',
      type2: '工单类型',
      status: '状态',
      operating: '操作',
      sendAnnex: '发送附件',
      recording: '沟通处理记录',
      reply: '回复',
      surname: '姓',
      name: '名',
      phone: '手机号码',
      email: '电子邮箱',
      viewWork: '详情工单',
      sendSuccess: '发送成功',
      submitSuccess: '工单提交成功',
      uploadTips: '附件大小不超过2M，支持图片和pdf格式，最多不超过9张',
      submitSuccessMessage: '请耐心等待，管理员正在认真的处理您的工单～',
      details: '详情',
      viewWorks: '查看工单'
    },
    fastPayment: {
      title: '我的银行卡',
      addBankCard: '添加银行卡',
      add: '',
      add2: '',
      noCards: '暂无银行卡',
      cardsNumber: '卡号',
      cardsName: '持卡人姓名',
      phoneNumber: '手机号码'
    },
    acupon: {
      title: '卡券中心'
    },
    logOff: {
      title: '账户注销',
      Notice: '注销须知',
      noticeTitle: '在提交注销申请前，请仔细确认以下须知 :',
      notice1: '1.账号注销后，账户内的各类优惠券、订单信息等平台信息将被清空；',
      notice2: '2.若该账号存在未完成订单，请先将订单处理完成，再进行注销账户。',
      hasRead: '我已阅读',
      smsVerification: '短信验证',
      smsNotice1: '系统已发送一条验证信息到您的手机号码',
      smsNotice2: '请将您收到的验证码填入下面输入框中，并提交验证',
      smsErrorNotice1:
        '短信验证失败，请重新获取验证码！系统将重新发送一条新的验证信息到您的手机号码',
      smsErrorNotice2: '请将您收到的验证码填入下面输入框中，并提交验证',
      emailVerification: '邮箱验证',
      emailNotice1: '系统已发送一条验证信息到您的邮箱',
      emailNotice2: '请将您收到的验证码填入下面输入框中，并提交验证',
      emailErrorVerification: '邮箱验证失败',
      emailErrorNotice1: '邮箱验证失败，请重新获取验证码！系统将重新发送发送一条验证信息到您的邮箱',
      emailErrorNotice2: '请将您收到的验证码填入下面输入框中，并提交验证验证',
      iDAuthentication: '身份验证',
      IdDear: '尊敬的',
      idNotice1: '您正在进行Chinagoods账号注销的操作，请在下方输入您的身份证后六位数字，并提交验证',
      idErrorNotice1:
        '您输入的身份证后六位数字与系统信息不符请在下方重新输入您的身份证后六位数字，并提交验证',
      cancel: '取 消',
      submit: '确 定',
      logOffSucc: '注销成功',
      successNotice1: '感谢您对Chinagoods平台的使用，期待您的再次使用！',
      complete: '完成',
      doNow: '立即处理',
      notice: '提示',
      errorNotice1: '当前账号存在以下问题，请处理完之后再进行注销账户'
    },
    returns: {
      returnDetail: '退货详情',
      returnsTips1: '请选择退货商品并确认数量',
      returnsTips2: '请填写退货信息',
      reason: '退货原因',
      reasonMessage: '请选择退货原因',
      description: '问题描述',
      descriptionMessage: '请描述申请退货的具体原因',
      number: '申请件数',
      amount: '退款金额',
      return: '申请退货',
      cancel: '取消申请',
      returnDate: '退款时间',
      uploadTips: '为了帮您更好的解决问题，请务必上传照片凭证，最多可上传9张图片，每张大小不超过5M',
      orderNote: '订单备注',
      leaveMessage: '给商家留言'
    },
    account: {
      title: '外汇账户',
      addAccount: '新增外汇账户',
      accountManage: '外汇账户管理',
      changeAccount: '修改外汇账户',
      person: '付款人',
      accountNumber: '账户号码',
      setAccountNumber: '默认账号',
      payAccountNumber: '付款账号'
    },
    financial: {
      title: '金融服务'
    },
    purchase: {
      title: '采购需求',
      tList: '采购需求列表',
      publishNeed: '发布采购需求',
      // noNeed: '暂无需求',
      purProduct: '采购产品',
      Description: '产品描述',
      pic: '图片',
      Quantity: '数量(件)',
      price: '预估单价（元）',
      note: '备注说明',
      basicInfo: '基本信息',
      proType: '找货类型',
      allpro: '公开找货',
      allpro1: '定向找货',
      allpro2: '找货品类',
      allpro3: '截止时间',
      allpro4: '供货时间',
      allpro5: '补充说明',
      selectShop: '选择店铺',
      shopName: '店铺名称',
      category: '可选择3个一级分类'
    },
    hotel: {
      title: '酒店订单',
      allOrder: '所有订单',
      pendingPayment: '待支付',
      paid: '已支付',
      confirmed: '已确认',
      userCancel: '已取消',
      systemCancel: '系统取消',
      backgroundCancel: '后台取消',
      refund: '已退款',
      hotelSearch: '按酒店名称搜索'
    },
    interLogistics: {
      title: '国际物流订单',
      allOrder: '所有订单',
      pendingPayment: '待支付',
      paid: '已支付',
      confirmed: '已确认',
      userCancel: '已取消',
      systemCancel: '系统取消',
      backgroundCancel: '后台取消',
      refund: '已退款',
      hotelSearch: '按酒店名称搜索'
    },
    paymentList: {
      title: '货款宝'
    },
    inquiryList: {
      title: '询价列表'
    },
    logistics: {
      purchase: '物流采购需求',
      order: '物流采购订单',
      PurchaseOrder: '采购单号',
      Orderid: '订单号',
      type: '类型',
      Status: '状态',
      Deadline: '截止时间',
      Quoted: '已报价',
      all: '全部',
      paid: '待支付',
      Shipped: '待发货',
      received: '待收货',
      Canceled: '已取消',
      WriteReviews: '待评价',
      completed: '已完成',
      Method: '采购方式',
      Directpurchase: '直接购买订单',
      InquiryPurchase: '询价采购订单',
      ServiceProvider: '服务商名称'
    }
  },
  commodity: {
    commodityInfo: '商品信息',
    attributes: '属性值',
    unitPrice: '单价',
    quantity: '数量',
    subtotal: '小计',
    weight: '重量',
    operating: '操作',
    title: '请确认订单信息'
  },
  cart: {
    addCart1: '加入进货单',
    addCart2: '填写提交订单信息',
    addCart3: '订单支付',
    addCart4: '支付结果',
    settlement: '去结算',
    sign_pay: '签约/付款',
    totalPrice: '合计',
    discount: '折扣',
    clearCart: '清空进货单',
    deleteCommodity: '删除选中商品',
    inStock: '有货',
    soldOut: '无货',
    selectAddress: '请选择收货地址',
    selectShippingMethods: '请选择物流方式',
    confirmOrder: '确认订单信息',
    freight: '运费',
    taxrate: '关税',
    theAmountOfGoods: '商品金额',
    merchantOffers: '商家优惠',
    grossWeight: '总重',
    totalPayable: '应付总额',
    backToCart: '回进货单',
    toCart: '去进货单',
    submitOrders: '立即支付',
    recentlyJoined: '最近加入的商品',
    shoppingCartTotal: '进货单里共',
    pieces: '件',
    backToHome: '返回首页',
    checkOrder: '查看订单',
    purchase: '前往自提 / 物流采购',
    paySuccess: '付款成功',
    repay: '重新付款',
    paySuccessMessage: '您已完成付款',
    payError: '付款失败',
    payErrorMessage: '付款遇到问题，请尝试重新支付',
    showAddress: '更多地址',
    hideAddress: '收起地址',
    showOrderer: '选择其他订购人',
    hideOrderer: '选择其他订购人',
    payTheBalance: '支付尾款',
    toSignUp: '去签约',
    toPayDeposit: '支付定金',
    deleteOrder: '删除订单',
    toPay: '去支付',
    addCart5: '确认合同',
    title: '合同协议条款如下',
    pdf: '订单合同.pdf',
    linkType: '链接查看您刚才签订的合同，您也可在订单中心中查看。查看完成不要忘了支付定金哦～',
    canClick: '可点击',
    paySuccess1: '定金支付成功',
    payTips: '付款可能会有延迟，具体信息请前往订单中心查看',
    fare: '运费',
    taxMoney: '税费',
    orderPrice: '订单金额',
    cartEmpty: '您的进货单是空的快去逛逛吧',
    shopAround: '去逛逛'
  },
  customer: {
    feedback: '问题反馈',
    phone: '客服电话',
    email: '服务邮箱'
  },
  publicText: {
    location: '当前位置',
    noData: '暂无数据',
    searchTips: '搜索商品关键词',
    searchTipsTwo: '店铺名/手机号',
    clickUpload: '点击上传',
    chosen: '已选择',
    list: '列表',
    map: '地图',
    sales: '销量',
    sold: '销量', // 后跟商品数量
    Fcollect: '收藏',
    haveCollect: '已收藏',
    SalesRevenue: '销售额',
    price: '价格',
    favorite: '收藏商品',
    toBeCollected: '关注',
    collected: '已关注',
    commodity: '商品',
    commodity2: '商品', // 英文为空
    shop: '店铺',
    watch: '观看',
    hello: '您好，用户',
    welcome: '义乌欢迎您 !',
    user: '用户',
    clickwhatIsProcurement: '什么是全场景采购？',
    whatIsProcurement: '全场景采购（Omni-scenario Purchasing)',
    procurement:
      '在小商品采购过程中，交易有可能会发生在各种不同场景中——譬如有可能是在线下的门店选择货品后直接刷卡进行交易，有可能是将线下广告中的二维码进行扫码交易，有可能是老客户通过银行转账来进行大额交易；还有可能是线上电商店铺进行线上下单交易，在微信聊天对话中发送商品链接进行交易，或者是在直播过程中直接购买形成交易等等。义乌小商品城数字化系统“全场景采购”的设计目标就是，无论您是在上述哪种场景中交易，我们的系统都可以从技术手段上支撑该场景中从下单到支付到物流等交易的各个环节，促进交易达成。并且通过数字化手段，将传统线下场景与线上场景中的交易信息相融合，从而让采购双方在系统中都可以对全场景下的各个采购活动进行数字化管理与追踪。',
    QA: '购物问答',
    grabbed: '已抢',
    endOfDistance: '距离结束',
    pieces: '件',
    productDetails: '商品详情',
    ranking: '排行',
    storeRanking: '相关店铺推荐',
    productsRecommended: '类似商品推荐',
    recommendedForYou: '为您推荐',
    sorry: '抱歉，没有找到与',
    relatedProducts: '相关的商品',
    allMarkets: '全部市场',
    explosion: '爆款推荐',
    found: '搜索到',
    relatedShops: '相关的店铺',
    home: '家',
    mapMode: '地图模式',
    listMode: '列表模式',
    uploadAttachment: '上传附件',
    rate: '评分',
    post: '发表',
    vipPrice: '会员价',
    desc: '描述文字',
    sameProducts: '同款产品',
    tips: '合同交易、线下转账只支持单店铺交易。合同交易需个人/企业实名认证。',
    noGoods: '进货单中暂无商品',
    day: '天',
    hour: '时',
    minute: '分',
    second: '秒',
    hotGoods: '爆款商品推荐',
    issudeTime: '上架时间',
    haveVideo: '有视频',
    haveNotFand: '没找到想要的？试试发个找货需求吧',
    publishSearch: '发布找货需求',
    searchGoods: '要找货品',
    Lpic: '参考图片',
    productDetail: '货品说明',
    quickSearch: '立即找货',
    shopInSearch: '店内搜索',
    keyCode: '关键字',
    businessLice: '经营执照',
    verified: '已审核',
    noVerified: '未审核',
    view: '查看',
    rating: '信用评分',
    inShop: '进店逛逛',
    addList: '收藏店铺',
    cancelList: '取消收藏',
    shopZ: '店铺资质',
    brand: '品牌',
    brandId: '商品编号',
    weight: '商品重量',
    name: '商品名称',
    proType: '分类',
    size: '规格',
    source: '产地',
    proInfo: '产品参数',
    proDes: '产品描述',
    proPic: '产品展示图',
    saleTop: '销量榜',
    collectTop: '收藏榜'
  },
  btn: {
    search: '搜索',
    searchAll: '搜全站',
    searchShop: '搜本店',
    more: '更多',
    addCart: '加入进货单',
    buy: '立即购买',
    moreOptions: '更多选项',
    putAway: '收起',
    determine: '确定',
    cancel: '取消',
    multipleChoice: '多选',
    send: '发送',
    delete: '删除',
    selectAll: '全选',
    modify: '修改',
    submit: '提交',
    company: '浙江中国小商品城集团股份有限公司',
    title: '关于外籍采购商来义采购的奖励办法',
    explains:
      '请发起申请企业及时告知所邀外商，此次享受补贴的必要条件如下：必须要有5万美元以上的交易凭证（采购合同+汇款凭证），必须是非人民币的外汇收款，收款方一定要是注册在义乌的企业。',
    tips:
      '若您通过补贴条件审核，且您所在的国家/地区有航班直达义乌，我们将提供目的地为义乌的单程机票补贴（经济舱）；若您所在的国家/地区无航班直达义乌，我们将提供最终目的地为义乌的不超过一次转机的单程联程机票补贴（经济舱）。',
    month: '2020年2月19日',
    illustration: '说明',
    Directflight: '单程',
    oneTransit: '一次转机',
    Transit: '转机',
    Application: '外商来义采购',
    word: '行宿补贴申请表',
    noFree: '说明：3月10日之后来到义乌的友商，不享受免费食宿 。酒店由商城集团指定。',
    time: '发车时刻表'
  },
  application: {
    slgon: '外商/华侨来义采购行宿补贴申请表',
    yourName: '2.姓名',
    placeholderSurname: '请输入姓',
    placeholderName: '请输入名',
    yourSex: '3.性别',
    male: '男',
    female: '女',
    sexRule: '请选择性别',
    nameRule: '请输入名',
    surnameRule: '请输入姓',
    yourBirthday: '4.出生日期',
    birthdayRule: '请选择出生日期',
    birthdayArrivalDate: '请选择预计抵达日期',
    passportCountry: '5.护照颁发国家/地区',
    pleaseChoose: '请选择',
    passportNumber: '6.护照号码',
    passportCountryRule: '请输入护照颁发国家/地区',
    pleaseInput: '请输入',
    contactWays: '7.联系方式',
    domesticTel: '中国手机',
    overseasTel: '国外手机',
    overseasTelInput: '在中国境外可联系到申请人的手机号',
    domesticTelInput: '在中国境内可联系到申请人的手机号',
    email: '电子邮箱',
    placeholderTel: '自己或是中国境内联系人手机号码',
    domesticTelCue: '提示：可以填自己或是中国境内联系人手机号码',
    flightInfo: '8.拟定航班信息',
    airlineCompany: '航空公司',
    flightNumber: '航班号码',
    departureDate: '起飞日期',
    arrivalDate: '9.预计抵达义乌日期',
    time: '选择日期',
    explain: '说明：',
    type2list1: '补贴来义航班经济舱费用50%',
    type2list2: '三日酒店免费食宿，酒店由商城集团指定',
    type2list3: '离义航班费用不纳入补贴范围。',
    type3:
      '2月29日前抵义15日内在义采购金额在5万美元以上，航班经济舱费用全额补贴；3月1日至10日间抵义，15日内在义采购金额在5万美元以上，航班经济舱费用补贴50%。离义航班费用不纳入补贴范围。',
    address: '10.在义乌住址',
    city: '市',
    street: '街镇',
    detailAddress: '详细地址：',
    freeAccommodation: '需安排免费住宿',
    homeAddress: '自有居所',
    hotelTime: '酒店住宿日期：',
    startTime: '入住日期',
    endTime: '离店日期',
    adslist1: '2月29日前抵义，最长享受7天免费食宿；',
    adslist2: '3月1日至10日间抵义，最长享受3天免费食宿。',
    adslist3: '酒店由商城集团指定。',
    adslist4: '说明：3月10日前抵义的，提供三日免费食宿，酒店由商城集团指定。',
    cashExplain: '补贴兑现说明：',
    explainTxt:
      '1.外商并经义乌外贸企业事前备案的，在义期间同义乌商贸企业或市场经营户采购金额在五万美元以上并审核有效的，携带采购合同及汇款凭证，前往义乌小商品城采购商服务中心（义乌市国际商贸城四区1楼南2号门）兑现补贴。本办法由商城集团负责解释。',
    purchaserType: '1.采购商类型',
    purchaserType1: '第一类：在义乌注册的商贸型企业外籍股东或外籍法定代表人',
    purchaserType2: '第二类：在义乌有出入记录且有采购记录的外籍采购商',
    purchaserType3: '第三类：在义乌无出入记录或无采购记录的外籍采购商',
    purchaserType4:
      '第四类：有国外长居或永居身份、在境外注册有商贸企业的股东或法人代表、且有义乌出入境记录的中国籍采购商',
    accessRecords: '出入记录：',
    purchaseRecord: '采购记录：',
    cue1: '提示：请提供相关文件证明，支持图片和pdf文件。',
    cue2: '出入记录：2020年1月1日之前的义乌出入境记录、义商友卡、义乌酒店入住记录任一种。',
    cue3: '采购记录：2020年1月1日之前的同义乌商贸企业或市场经营户的资金往来凭证。',
    enclosure: '附件：',
    enclosure1: '居留许可文件：',
    enclosure2: '经营许可文件：',
    cue4: '提示：请提供义乌商贸企业营业执照照片或扫描件，支持图片和pdf文件。',
    cue5:
      '提示：请提供请提供义乌外贸企业或市场经营户基础信息（加盖公章的营业执照或工商证明照片或扫描件） ，支持图片和pdf文件。',
    cue6: '提示：',
    cue7: '(1) 由境外国家外国人管理局或类似职能部门下发的居留许可文件的扫描件。',
    cue8: '(2) 由境外国家商管部门下发的商贸型企业经营执照等文件，或股东证名。',
    cue9: '(3) 2020年1月之前在义乌的出入境记录、来义交通凭证或义乌酒店入住记录。',
    cue0:
      '(4) 2020年1月之前，以本人或注册公司为主体，在义乌生成的采购金额不小于5万美金的订单或资金往来凭证。',
    agree: '我已知晓并接受',
    agreement: '《关于外籍采购商来义采购的奖励办法》',
    companyContant: ' 11.义乌境内发起邀请单位联系方式',
    companyName: '单位名称',
    companyPerson: '联系人',
    companyTel: '手机号码',
    sendEmailCue: '如不方便网页提交，可发申请邮件到 ',
    emailAds: 'freetoyiwu@chinagoods.com',
    passportNumberRule: '请输入护照号码',
    emptyRule: '内容不能为空',
    endtimeRule: '请选择结束时间',
    submit: '提交',
    company: '浙江中国小商品城集团股份有限公司',
    title: '关于外籍采购商来义采购的奖励办法',
    explains:
      '请发起申请企业及时告知所邀外商，此次享受补贴的必要条件如下：必须要有5万美元以上的交易凭证（采购合同+汇款凭证），必须是非人民币的外汇收款，收款方一定要是注册在义乌的企业。',
    tips:
      '若您通过补贴条件审核，且您所在的国家/地区有航班直达义乌，我们将提供目的地为义乌的单程机票补贴（经济舱）；若您所在的国家/地区无航班直达义乌，我们将提供最终目的地为义乌的不超过一次转机的单程联程机票补贴（经济舱）。',
    month: '2020年2月19日',
    illustration: '说明',
    Directflight: '单程',
    oneTransit: '一次转机',
    Transit: '转机',
    Application: '外商来义采购',
    word: '行宿补贴申请表',
    noFree: '说明：3月10日之后来到义乌的友商，不享受免费食宿 。酒店由商城集团指定。'
  },
  welecomeToYiWu: {
    toDeclare: '去申报',
    toApply: '去申请',
    toHotel: '去预定',
    hotel: '酒店预订',
    currentPosition: '当前位置',
    convention: '会展参展商申报',
    name: '姓名',
    Gender: '性别',
    man: '男',
    women: '女',
    idType: '证件类型',
    idNumber: '证件号码',
    Nationality: '国籍',
    Province: '省份',
    city: '城市',
    companyAddress: '公司地址',
    companyName: '公司名称',
    jobTitle: '职位',
    Department: '部门',
    Contacts: '联系方式',
    email: '邮箱',
    interest: '您感兴趣的类别是（可多选）',
    companyBusiness: '您公司的业务性质是（可多选）',
    others: '其他（请列明）',
    attend: '您的参会目的（可多选）',
    wayConcatType: '您希望执委会以何种方式联系您参会（单选）',
    submit: '提交',
    purchaser: '采购商健康申报',
    declareChoose: '申报选择',
    placeLocation: '户籍所在地',
    foreignCard: '有无商友卡',
    yes: '有',
    no: '无',
    currentYiWuAddress: '义乌现住址',
    currentHealthy: '本人目前身体状况',
    Fever: '发热',
    Cough: '咳嗽',
    Ingoodhealth: '健康',
    daysOut: '前14天本人外出情况',
    type1: '1、湖北、温州、台州往返情况',
    type2: '2、与确诊病例或其密切接触者聚集情况',
    type3: '3、有无流行病学史、有无症状',
    familyMembers: '本人及家庭成员与病患接触情况',
    commitmentChecked: '本人承诺以上情况属实，如有不实之处，愿意承担相应法律责任',
    entry: '外国人入境申请表',
    type: '类型',
    phone: '电话',
    chineseName: '中文名',
    dateOfBirth: '出生日期',
    placeOfBirth: '出生地',
    passportType: '护照类型',
    passportNumber: '护照号码',
    IssueDate: '签发日期',
    validityOfPassport: '护照有效期',
    entryTime: '入境时间',
    validityOfVisa: '签证有效期',
    visaNumber: '签证号码',
    visaType: '签证种类',
    word1: {
      pleaseEnter: '请输入',
      placeSelect: '请选择',
      pleaseName: '请输入姓名',
      pleaseSex: '请选择性别',
      pleaseIdType: '请选择证件类型',
      pleaseIdNumber: '请输入证件号码',
      pleaseLegalIdNumber: '请输入合法身份证号',
      pleaseCountry: '请选择国籍',
      pleaseArea: '请选择所在地区',
      pleaseDetailAddress: '请输入详细地址',
      pleaseCompanyName: '请输入公司名称',
      pleaseDepartment: '请输入部门',
      pleasePosition: '请输入职位',
      pleaseContant: '请输入正确的联系方式',
      pleaseLegal: '请输入合法手机号/电话号',
      pleaseEmail: '请输入正确的邮箱',
      pleaseInterested: '请勾选您感兴趣的类别',
      pleaseBussiness: '请勾选您公司的业务性质',
      pleaseAttendPurpose: '请勾选您参会的目的',
      pleaseWitchConcatType: '请勾选您期望执委会以何种方式联系您参会',
      pleaseWitchConcatNumber: '请填写您勾选的期望执委会以何种联系您参会的方式',
      placeType: '请选择类型',
      placeChineseName: '请输入您的中文名',
      dateOfBirth: '请选择您的出生日期',
      placeOfBirth: '请输入您的出生地',
      placePassportType: '请选择您的护照类型',
      placePassportNumber: '请输入您的护照号码',
      placeIssueDate: '请选择您的护照的签发日期',
      placeValidityOfPassport: '请选择您的护照有效期',
      placeEntryTime: '请选择您的入境时间',
      placeValidityOfVisa: '请选择您的签证有效期',
      placeVisaNumber: '请输入您的签证号码',
      placeVisaType: '请输入您的签证种类',
      placeDeclare: '请选择申报选择',
      placeDomicileLocation: '请输入户籍所在地',
      placeFriendsBusinessCard: '请选择您是否有友商卡',
      placeCurrentAddress: '请输入您在义乌的现住址',
      placeCurrentHealth: '请勾选您本人目前的身体状况',
      placeDaysOut: '请勾选您前14天外出情况',
      placeFamilyMembers: '请选择您本人及家庭成员与病患解除情况'
    },
    declareType1: '非疫情重点区域的国内采购商（A类）',
    declareType2: '湖北省，温州市，台州市等疫情严重地区的国内采购商（B类）',
    declareType3: '常驻义乌的国外采购商（C类）',
    declareType4: '非常驻义乌的国外采购商（D类）',
    idcardType1: '身份证',
    idcardType2: '护照',
    idcardType3: '澳门来往内地通行证',
    idcardType4: '台湾来往内地通行证',
    idcardType5: '香港来往内地通行证',
    concatType1: 'email',
    concatType2: '微信',
    concatType3: '电话',
    concatType4: 'QQ',
    visaType1: '签证类',
    visaType2: '外国人来华工作许可',
    visaType3: '在义乌公司新设',
    passportType1: '外交',
    passportType2: '公务/官员',
    passportType3: '普通',
    passportType4: '其他'
  },
  logisticsSide: {
    title: '商城托运申请',
    logan: '请先登录后申请商城托运',
    sender: '寄',
    senderInfo: '寄件方信息',
    recipient: '收',
    recipientInfo: '收件方信息',
    name: '姓名',
    placeholder: '请输入',
    placeholderSelect: '请选择',
    company: '公司',
    telephone: '手机号码',
    fixedTelephone: '固定电话',
    country: '国籍',
    area: '所在地区',
    detailAddress: '详细地址',
    checkedItems: '托运物品',
    checkedName: '托运物品名称',
    cloume: '长x宽x高(cm)',
    weight: '重量(kg)',
    delete: '删除',
    addChecked: '新增托运物品',
    othersInfo: '其他信息',
    startTime: '期望发货时间',
    endTime: '期望到货时间',
    desc: '托运内容物描述',
    success: '提交成功',
    info: '请耐心等待，管理员正在认真的处理您的需求～',
    newWord: '新建申请表',
    submit: '提交托运申请',
    pleaseName: '请输入姓名',
    pleaseTelephone: '请输入手机号码',
    pleaseLegal: '请输入合法手机号/电话号',
    pleaseCountry: '请选择国籍',
    pleaseArea: '请选择所在地区',
    pleaseDetailAddress: '请输入详细地址',
    pleaseCheckedItemName: '请输入托运物品名称',
    pleaseVolume: '请输入托运物品的长宽高',
    pleaseWeight: '请输入托运物品的重量',
    drag: '将文件拖到此处，或',
    expressName: '物流公司',
    expressNo: '运单号'
  },
  newFeedback: {
    location: '当前位置',
    newWord: '新建工单',
    firstname: '姓',
    surname: '名',
    telphone: '手机号码',
    email: '电子邮箱',
    type: '工单类型',
    desc: '问题描述',
    dialogImageUrl: '上传附件',
    submit: '提交',
    uploadTips: '附件大小不超过2M，支持图片和pdf格式，最多不超过9张',
    pleaseTelephone: '请输入手机号码',
    pleaseType: '请选择类型',
    pleaseDesc: '请输入问题描述'
  },
  articleList: {
    title: '文章列表',
    releasetime: '发布时间'
  },
  antiepidemic: {
    purchaserRegister: '采购商注册咨询',
    provideRegister: '供应商户注册咨询',
    viewMore: '查看更多',
    location: '当前位置',
    epidemicZone: '防疫专区',
    firstname: '姓',
    surename: '名',
    telephone: '手机号码',
    country: '国籍',
    idcardPic: '身份证照片',
    idcardPositive: '身份证正面',
    idcardOtherSide: '身份证反面',
    uploadTips: '*证照图片支持JPG、PNG、BMP等格式，单张图片大小不超过20M！',
    desc: '咨询描述',
    submit: '提交',
    pleaseName: '请输入',
    placeTelephone: '请输入手机号码',
    placeCountry: '请选择国籍',
    placeIdcardPic: '请上传身份证的正反面',
    placeDesc: '请输入咨询描述',
    placeSelect: '请选择'
  },
  account: {
    myInfotitle: '个人信息',
    username1: '用户姓名',
    modify: '修改',
    username: '昵称',
    lagonName: '登录名',
    country: '国籍',
    intetion: '采购意向',
    contractStatus: '合同注册状态',
    certified: '已认证',
    notCertified: '未认证',
    notSetting: '未设置',
    notRegister: '未注册',
    applyRegister: '申请注册',
    failRegister: '注册失败',
    contactManager: '请提交工单联系管理员',
    registered: '已注册',
    isTImed: '到期',
    overTime: '已过期',
    againRegister: '重新注册',
    add: '新增',
    tips: '如果您想体验我们最新的合同交易方式，请先完成',
    paySurename: '付款人姓',
    payFirstname: '付款人名',
    payAccountNumber: '付款人账号',
    payCountry: '付款人国籍',
    receiveGoods: '收货人邮箱',
    title: '账号登陆',
    placeholderUser: '用户名',
    placeholderPassword: '密码',
    noLogin: '7天内免登录',
    submit: '登录',
    goRegister: '获取验证码',
    invationCode: '邀请码',
    cue1: '如果是企业请',
    cue2: '企业认证'
  },
  sideMenu: {
    learnMore: '了解更多活动资讯',
    code: '关注/扫码微信公众号'
  },
  submitOrder: {
    contractType: '交易方式',
    noContract: '非合同交易',
    Contract: '合同交易',
    outsideContract: '外汇交易',
    linkType: '合同交易，请确认是否已经实名认证，可通过此链接进行',
    linkTypeContract: '合同交易',
    linkTypeForeign: '外汇交易',
    linkTypeMessage: '需要实名认证，请前往认证：',
    personCer: '个人实名认证',
    companyCer: '企业实名认证',
    payAccount: '请选择付款账号',
    addAccount: '新增付款账号',
    selectAddress: '收货人信息',
    selectOrderer: '请选择订购人',
    addAddress: '新增收货地址',
    orderer: '新增订购人',
    selectLogistics: '请选择物流方式',
    businessExpress: '卖家发运',
    mallExpress: '买家自理',
    tips: '选择卖家发运，由卖家为您提供物流服务',
    tips2: '选择买家自理，您无需在订单中支付运费，由您自理物流服务。',
    tips3: '提示：目前平台暂无物流服务可购买。',
    tips4: '因海关购买人与支付人需一致',
    tips5: '购买保税商品时，请确保在详情地址内填写乡镇或街道名称，否则货物将无法配送',
    accountList: {
      addaAddress: '请新增一个收货地址',
      addOrderer: '请新增一个订购人',
      addAccount: '请新增一个外汇账号',
      name: '联系人姓名',
      placeholderOrdererName: '请输入订购人姓名',
      placeholderOrdererNumber: '请输入证件号码(限定18位)',
      placeholderName: '请输入联系人姓名',
      placeholdTelephone: '请输入电话号码',
      addAddress: '新增地址',
      placeRecipientName: '收货人姓名',
      changeAddress: '修改地址',
      changeOrderer: '修改订购人'
    },
    note: '提示'
  },
  message: {
    sure: '确定',
    cancle: '取消',
    tips: '提示',
    tips1: '视频出错，错误原因：',
    tips2: '确认删除该件商品吗?',
    tips3: '删除成功!',
    tips4: '已取消删除',
    tips5: '添加成功，在进货单等亲~',
    tips6: '上传文件类型必须是JPG、JPEG、PNG或者BPM!',
    tips7: '上传文件大小不能超过 2MB!',
    tips8: '图片识别失败，请重新上传身份证正面照',
    tips9: '未选中任何商品',
    tips10: '此操作将清空进货单, 是否继续?',
    tips11: '暂不支持多店铺同时结算, 请重新选择！',
    tips12: '已取消此收藏',
    tips13: '收藏成功',
    tips14: '当前为私密视频,暂未对您开放',
    tips15: '当前为私密视频,请登录账号后重试',
    tips16: '删除后无法恢复，确认删除吗？',
    tips17: '设为默认成功',
    tips18: '添加成功',
    tips19: '修改成功',
    tips20: '设置成功',
    tips21: '上传文件类型必须是JPG、JPEG、PNG、GIF或者PDF!',
    tips22: '上传文件大小不能超过 5MB!',
    tips23: '确定删除此条消息?',
    tips24: '请先完成实名认证',
    tips25: '注册成功',
    tips26: '验证码发送成功',
    tips27: '验证码已发送',
    tips28: '删除订单?',
    tips29: '删除订单成功',
    tips30: '暂未开放',
    tips31: '已处理完成的不能再回复了哦',
    tips32: '上传文件大小不能超过 2MB!',
    tips33: '该店铺尚未开通客服,请稍后',
    tips34: '您暂无权限观看',
    tips35: '您已经是聊天室成员了，请勿重复加入哦！',
    tips36: '加入聊天室成功',
    tips37: '申请成功，等待群管理员确认。',
    tips38: '此操作将删除该账号, 是否继续?',
    tips39: '请添加收货地址',
    tips40: '是',
    tips41: '否',
    tips42: '是否支付成功?',
    tips43: '此操作将删除该地址, 是否继续?',
    tips44: '商家正在快马加鞭为您制作合同，请耐心等待。',
    tips45: '知道了',
    tips46: '删除后地址无法恢复，确认删除吗？',
    tips47: '新建成功',
    tips48: '撤销退货后，该商品不可再申请退货，确认撤销退货吗？',
    tips49: '不能发送空消息哦',
    tips50: '确认关闭',
    tips51: '暂无未读消息',
    tips52: '查看所有',
    tips53: '刷新成功',
    tips54: '没有找到该用户',
    tips55: '最多只能上传9张图片',
    tips56: '删除失败',
    tips57: '请添加外汇账号！',
    tips58: '库存不足',
    tips59: '已取消此关注',
    tips60: '关注成功',
    tips61: '已发送',
    tips62: '此操作将删除该购买人, 是否继续?',
    tips63: '请添加购买人'
  },
  foreign: {
    title: '外汇订单内容',
    businessSure: '等待商家确认',
    orderNo: '订单号码',
    price: '应付金额',
    payMethods: '付款方式',
    type1: '第一期',
    type2: '第二期',
    type3: '第三期',
    confirmInfo: '确认信息',
    rmbTotal: '人民币总价',
    proposeTotal: '目标币种总价'
  },
  identifier: {
    tips: '订单提交成功，请尽快付款',
    readInfo: '请仔细阅读以下信息',
    type1: '1、请注意，本次订单约定的支付方式为中国工商银行监管支付。',
    type2: '2、打款时请务必在附言内注明对应付款的支付码，否则钱款将无法进入中国工商银行进行监管。',
    type3: '3、请勿使用其他方式付款，否则钱款将无法进入中国工商银行进行监管。',
    type4: '4、请按照打款顺序附言对应正确的支付码。',
    type5: '5、如果因个人失误造成的损失，chinagoods平台，中国工商银行将不承担任何责任。',
    collectAccountInfo: '收款账户信息:',
    payCodeInfo: '支付码信息',
    tips1:
      '注意：打款时请务必在附言内注明对应付款的支付识别码，否则钱款将无法进入中国工商银行进行监管',
    number: '收款账户',
    payCode: '支付码识别码',
    pay: '支付金额',
    bank: '收款银行',
    payee: '收款人',
    payeeAccount: '收款账号',
    payeeAddress: '收款人地址',
    contant: '联系人',
    telephone: '联系电话'
  },
  chat: {
    cancelBlackout: '取消拉黑',
    tips1: '黑名单还是空的',
    noNickname: '该用户未设置昵称',
    joinBlackList: '将该用户加入黑名单',
    joinBlack: '加入黑名单',
    removeBlackList: '将该用户移出黑名单',
    removeBlack: '移出黑名单',
    deleteSession: '删除会话',
    systemInfo: '系统通知',
    mentioned: '[有人提到我]',
    refreshList: '刷新列表',
    startSession: '快速发起会话',
    pleaseUserId: '请输入用户ID',
    viewDetail: '查看详细信息',
    noMore: '没有更多了',
    backLatest: '回到最新位置',
    editProfile: '编辑个人资料',
    headPortrait: '头像',
    nickname: '昵称',
    pleaseHeadPro: '头像地址(URL)',
    noDisplay: '不显示',
    tips2: '头像应该是 Url 地址',
    sessionList: '会话列表',
    balckList: '黑名单列表',
    close: '关闭',
    rateAndProposal: '对IM DEMO的评分和建议',
    custom: '您可以自行解析自定义消息',
    clickDownload: '单击下载',
    clickDetail: '点击查看详情',
    handle: '处理',
    handleGroupApp: '处理加群申请',
    processResult: '处理结果：',
    agree: '同意',
    refuse: '拒绝',
    postscript: '附言：',
    pleasePostscrpt: '请输入附言',
    clickPlay: '单击播放',
    onPhone: '来电话了',
    onPhoning: '正在呼叫',
    noCamera: '摄像头未打开',
    cameraPower: '请确认已连接摄像头和麦克风并授予其访问权限！',
    withdraw: '撤回',
    reEdit: '重新编辑',
    notSupportMessageType: '暂未支持的消息类型：',
    expression: '发表情',
    sendCustomMessage: '发自定义消息',
    rateAndUse: '对IM Web demo的建议和使用感受',
    suggest: '建议',
    tips3: '按Enter发送消息，Ctrl+Enter换行',
    notSupportMessage: '暂不支持此消息',
    welcome: '欢迎：',
    joinChat: '加入聊天室',
    groupMembers: '群成员：',
    exitChat: '退出聊天室',
    kickoutGroup: '踢出群组',
    cover: '被',
    becomeAdmain: '成为管理员',
    revokedAdmain: '被撤销管理员',
    changeGroupDetail: '群资料修改',
    changeMemberDetail: '群成员资料修改',
    groupMessage: '[群提示消息]',
    groupSystemMessage: '群系统通知',
    systemMessage: '系统通知',
    preview: '预览',
    conversation: '会话'
  },
  private: {
    privateGoods: '私密商品',
    enterProPas: '输入商品密码',
    passwordError: '密码错误',
    price: '价格',
    startBatch: '起批量',
    viewPrivateGoods: '查看私密商品',
    pleaseholderPrivate: '请输入私密商品密码'
  },
  bargain: {
    num: '万',
    yi: '亿+',
    orders: '月成交',
    dan: '单',
    weeks: '周成交',
    turnover: '成交量',
    saleTop: '成交量榜'
  },
  zhenmodify: {
    door: '门到门',
    port: '港到港',
    price: '价格',
    ratings: '综合评分',
    sellerrating: '店铺等级',
    currentpoint: '当前积分',
    livevideo: '直播视频',
    ALLMarkets: '全部市场',
    Collection: '收藏',
    Navigation: '进入导航',
    Bulletin: '商铺公告',
    Replay: '查看回放',
    LiveIntroduction: '简介',
    Nointroduction: '暂无简介',
    Views: '观看',
    Products: '宝贝',
    LiveReplay: '视频回放',
    startquantity: '起批量',
    Quantity: '数量',
    Cart: '加入进货单',
    Buy: '立即购买',
    Liveing: '正在播放',
    View: '查看视频',
    Noscore: '暂无评分',
    Viewers: '观看',
    points: '分'
  },
  loginPage: {
    pleasePhoneNumber: '请输入手机号码',
    pleasePassword: '请输入登录密码',
    pleasePassword2: '请输入6-20位登录密码',
    pleaseCode: '请输入验证码',
    getCode: '获取验证码',
    pleaseCodeLogin: '验证码登录',
    pleasePasswordeLogin: '手机号登录',
    btnText: '登录',
    pleaseAccoutLogin: '账户名/邮箱/手机号',
    pleaseNewPassword: '请输入新密码',
    pleaseConfirmNewPassword: '请再次确认新密码',
    pleaseRegisterCode: '请输入邀请码'
  }
}
